export default __webpack_public_path__ + "static/media/route.6bd81c92.svg";